import { ResolveState } from '../../../common';
import { Updater } from '../../../upgrade/models/updater-interface';
import { ErrorResult } from '../../../upgrade/models/error-result';
import { Logger } from '../../utils/logger';

/**
 * Updater for LoadChildrenCallback errors.
 */
export class LoadChildrenCallbackUpdater implements Updater {
    /**
     * the update function.
     * @param fileData the file data.
     * @param error the error object.
     * @returns the updated file data.
     */
    public update(fileData: string, error: ErrorResult): Promise<string> {
        if (!fileData) {
            Logger.error(`Cannot find file data`);
        }

        const result = this.regexFixer(fileData);

        error.resolved = ResolveState.Resolved;
        return new Promise(resolve => resolve(result));
    }

    /**
     * the update function.
     * @param inputString the input file data string.
     * @returns the updated file data string.
     */
    private regexFixer(inputString): string {
        const regexPattern = /loadChildren:\s*'([^#']+#[^']+)'/;

        if (regexPattern.test(inputString)) {
            const replacedString = inputString.replace(regexPattern, (_match, modulePath) => {
                const [moduleFile, moduleName] = modulePath.split('#');
                return `loadChildren: () => import('${moduleFile}').then(m => m.${moduleName})`;
            });

            return replacedString;
        }

        return inputString;
    }
}
